import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b87acb38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scan" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_3 = { class: "item-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-scan" }, null, -1))
const _hoisted_5 = { class: "img-pay" }
const _hoisted_6 = { class: "title justify-content-between" }
const _hoisted_7 = { class: "d-inline-block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "qrcode",
  id: "qrcode"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "tip" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("请使用")
const _hoisted_14 = { class: "theme-color" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("扫一扫")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "二维码完成支付", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString($props.payType==='alipay' ? '支付宝支付':'微信支付'), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
          }, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          ($props.payType==='alipay')
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                width: "210",
                height: "210",
                src: $props.qrPath
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", null, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString($props.payType==='alipay' ? '支付宝':'微信'), 1),
            _hoisted_15
          ]),
          _hoisted_16
        ])
      ])
    ])
  ]))
}